/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class DependentDimension {
    getFixupPrototypeFunction() { return DependentDimension.fixupPrototype; }

    static newInstance(model: Partial<DependentDimension>): DependentDimension {
        let obj = Object.assign(new DependentDimension(), model);
        DependentDimension.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<DependentDimension>): DependentDimension {
        if (!model) return null;
        return DependentDimension.newInstance(<DependentDimension> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: DependentDimension) {
        if (!obj) return;

        models.DependentDimension.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: DependentDimension): boolean {
        Object.setPrototypeOf(obj, DependentDimension.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.priority === undefined) {
            this.priority = 0;
        }
    }

    /**
     * Id of the Dependent Dimension
     */
    dimension_id: string;

    /**
     * Ids of the Dependent Dimension Grouping rules
     */
    grouping_rule_ids: Array<string>;

    /**
     * Priority of the Dependent Dimension Grouping Rule for evaluation order
     */
    priority: number;

}
